import Input from "./Input";
import RadioGroup from "./RadioGroup";
import Select from "./Select";
import SelectBusType from "./SelectBusType";
import SelectBusTypeDisabled from "./SelectBusTypeDisabled";
import Checkbox from "./Checkbox";
import DatePicker from "./DatePicker";
import Button from "./Button";
import ActionButton from "./ActionButton";
import SelectPath from './SelectPath';
import SelectTripBus from './SelectTripBus'
import SelectBranch from './SelectBranch'
import SelectBranchDisabled from './SelectBranchDisabled'
import SelectBus from './SelectBus'
import SelectTypeTrip from './SelectTypeTrip'
import SelectPathFilter from './SelectPathFilter';
import SelectCity from './SelectCity';
import SelectTypeTrip2 from './SelectTypeTrip2';
import SelectGender from './SelectGender';
import SelectTrip from './SelectTrip';
import SelectTripDisabled from './SelectTripDisabled';
import SelectTripEdit from './SelectTripEdit';
import SelectTransferTrip from './SelectTransferTrip';
import SelectRole from './SelectRole';
import SelectBusType2 from './SelectBusType2';
import SelectTypeTripCart from './SelectTypeTripCart';
import SelectTypeidentifer from './SelectTypeidentifer';
import SelectTypeTripCart2 from './SelectTypeTripCart2';
import SelectTypeTripCart3 from './SelectTypeTripCart3';
import SelectBusType3 from './SelectBusType3';
import SelectBusTypeTwo from './SelectBusTypeTwo';
import PopupCreatePayment from "../PopupCreatePayment";
const Controls = {
    Input,
    SelectTypeTrip2,
    SelectBusType2,
    SelectBusType3,
    SelectBusType,
    SelectBusTypeTwo,
    SelectBranch,
    SelectBranchDisabled,
    SelectPath,
    SelectCity,
    SelectTripBus,
    SelectPathFilter,
    SelectGender,
    SelectRole,
    RadioGroup,
    Select,
    Checkbox,
    DatePicker,
    Button,
    SelectTypeTrip,
    SelectBusTypeDisabled,
    PopupCreatePayment,
    SelectTripEdit,
    SelectTransferTrip,
    SelectTypeTripCart,
    SelectTypeTripCart2,
    SelectTypeTripCart3,
    SelectTrip,
    SelectTripDisabled,
    SelectTypeidentifer,
    SelectBus,
    ActionButton
}

export default Controls;